import {
  FaDatabase,
  FaServer,
  FaCodeBranch,
  FaFeather,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-ferretdb.png";

export const FERRETDB_CONSTANTS = {
  HERO: {
    title: "OneMind Services — FerretDB (One-Click Application) ",
    desc: "An open-source MongoDB alternative built on PostgreSQL — ideal for PostgreSQL-backed NoSQL needs.",
    button: {
      label: "Deploy Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "FerretDB is an open-source, MongoDB-compatible document database that translates MongoDB wire protocol queries to SQL, using PostgreSQL as the backend. It allows users to run MongoDB workloads without the constraints of MongoDB's licensing.",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation :  Launch a fully configured and secure FerretDB instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high.",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes FerretDB engine, default admin credentials, and optimized system settings.",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "ferretdb",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access your FerretDB instance using the MongoDB-compatible connection string:",
      command: "mongodb://ferretdb:<generated password>@<YOUR_INSTANCE_IP>:27017/",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: "/etc/ferretdb/ferretdb.conf  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["27017 "],
    },
    note: "Note: Find the configuration file at /etc/ferretdb/ferretdb.conf for customized tweaks or backup",
  },
  FEATURES: {
    items: [
      {
        icon: FaDatabase,
        title: "MongoDB Compatibility",
        text: "Supports MongoDB wire protocol, enabling seamless integration with existing MongoDB tools and drivers.",
      },
      {
        icon: FaServer,
        title: "PostgreSQL Backend",
        text: "Utilizes PostgreSQL for data storage, combining the flexibility of document databases with the reliability of relational databases.",
      },
      {
        icon: FaCodeBranch,
        title: "Open-Source Licensing",
        text: "Free from MongoDB's SSPL license constraints, promoting transparency and community collaboration.",
      },
      {
        icon: FaFeather,
        title: "Lightweight and Efficient",
        text: "Designed for simplicity and performance, suitable for various deployment scenarios.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for FerretDB data and configurations.",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and access control configurations. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with PostgreSQL tools for enhanced performance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "FerretDB Documentation",
    docsLink: "https://docs.ferretdb.io/",
  },
};
